import { getAgencyConnections } from "@/actions-client/settings/actions";
import { AgencyConnection, OrgUserRestrictions } from "@/types/agencies";
import { MainAlertProps } from "@/types/common/alerts";
import { apiLive } from "@/lib/api";

export const FetchAgencyIntegrations = async (
  setIsLoading: (isSaving: boolean, text: string) => void,
  textForLoading: string
): Promise<AgencyConnection[] | null> => {
  try {
    setIsLoading(true, textForLoading);

    const data = await getAgencyConnections();

    setIsLoading(false, "");

    return data;
  } catch (error) {
    console.error(error);
    setIsLoading(false, "");
    return null;
  }
};

export const HandleOpenBillingSession = async (setAlert: (settings: MainAlertProps) => void) => {
  const session = await apiLive<{ url: string }>("/api/billing/session");

  if (!session) {
    setAlert({
      status: "error",
      message: "Failed to open billing, please contact support",
      secondsToClose: 10,
    });
    return;
  }

  window.open(session.url, "_blank");
};

export const GetDefaultOrgRestrictions = (): OrgUserRestrictions => {
  return {
    maxTotal: 5,
  };
};
